/* eslint-disable */
import { pinkThemegirl } from '../theme/images'
import {
    greenThemeLight, greenThemeDark, bwThemeLight, bwThemeDark, blueThemeLight, blueThemeDark, redThemeLight, redThemeDark, orangeThemeLight, orangeThemeDark, purpleThemeLight, purpleThemeDark, pinkThemeLight, pinkThemeDark, yellowThemeLight, yellowThemeDark
} from '../theme/theme'


export const themeData = {
    // theme: orangeThemeLight
    theme: orangeThemeDark
  
    
}


// Choose theme from above
